import React, { FC } from 'react';

export const IconImagePlaceholderBold: FC<React.PropsWithChildren<{ className?: string }>> = ({ className = '' }) => (
  <svg className={className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 9C12 10.1046 11.1046 11 10 11C8.89543 11 8 10.1046 8 9C8 7.89543 8.89543 7 10 7C11.1046 7 12 7.89543 12 9Z"
      fill="currentColor"
      fillOpacity="0.9"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      // eslint-disable-next-line max-len
      d="M5 2C3.34315 2 2 3.34315 2 5V19C2 20.6569 3.34315 22 5 22H19C20.6569 22 22 20.6569 22 19V5C22 3.34315 20.6569 2 19 2H5ZM19 4H5C4.44771 4 4 4.44772 4 5V16.5858L8 12.5858L10.5 15.0858L16 9.58578L20 13.5858V5C20 4.44771 19.5523 4 19 4ZM20 16.4142L16 12.4142L10.5 17.9142L8 15.4142L4.0633 19.3509C4.20542 19.7301 4.57119 20 5 20H19C19.5523 20 20 19.5523 20 19V16.4142Z"
      fill="currentColor"
      fillOpacity="0.9"
    />
  </svg>
);
